import {defineStore} from "pinia";
import {ref} from "vue";
import usePayloadBuilder from "@/usePayloadBuilder";

export const useModuleStatesStore = defineStore('module_state', () => {
    // states when loading, etc.
    const isLoading = ref(false)
    const isFilled = ref(true)
    const mode = ref('add')
    const copiedTransactions = ref()
    const entity_type = ref()
    const isFromAccounting = ref(true)
    const selected_taxes = ref([])
    const selected_data = ref([])
    const select_all_cbox = ref(false)
    const user_restriction = ref([])
    const user_permissions = ref({
        header: [],
        submodules: []
    })
    const table_options = { pageLength: 100 }
    const password_reqs = ref([-1, -1, -1, -1])
    let time_out
    const page_navigation = ref({
        current: '',
        initial: ''
    })
    const page_dates = ref({
        current: {},
        initial: {}
    })

    const audit_trail_list = ref({
        is_collapsed: 0,
        other_list: 0,
        list: []
    })

    const showInPageAlert = () => {
        clearInterval(time_out)
        isFilled.value = false
        time_out = setTimeout(() => {
            isFilled.value = true;
            clearInterval(time_out)
        }, 5000)
    }

    async function handleHistoryLogs (ref_num) {
        const is_collapsed = audit_trail_list.value.is_collapsed

        let response = await usePayloadBuilder("journal_entry", "get")
            .addPayload('conditions', {code: ref_num + ':logs:' + is_collapsed}).execute()
        if (response) {
            audit_trail_list.value.list = response.data.data.list
            audit_trail_list.value.other_list = response.data.data.count
            audit_trail_list.value.is_collapsed = audit_trail_list.value.is_collapsed ? 0 : 1
        }
    }

    function canUserAccess(module, submodule = null, sub_action = null) {
        let restriction = user_restriction.value, hasAccess = 0
        
        if(restriction[module]?.haveAccess ?? null) return true
        else return false
    }

    function checkUserAccess(module, submodule = null, action = null) {
        let headers = JSON.parse(localStorage.getItem('header')) ?? []
        let modules = JSON.parse(localStorage.getItem('submodules')) ?? []

        if(submodule === null) {
            if(headers.includes(module)) return true
            return false
        }
        if(Object.keys(modules).length < 1) return

        let child_module = modules[module][submodule] ?? []
        if(child_module.includes(action) && action !== null) {
            return true
        }
        return false
    }

    async function getPermissions(username) {
        let response = await usePayloadBuilder("user_restrictions", "get")
            .addPayload('conditions', {user_name: username}).execute()
        if (response) {
            response = response.data.data

            let perms = response.perms
            user_restriction.value = response
            user_permissions.value.header = response.perms.header
            user_permissions.value.submodules = response.perms.submodules

            localStorage.setItem('header', JSON.stringify(perms.header))
            localStorage.setItem('submodules', JSON.stringify(perms.submodules))
        }
    }

    function pageNavigationWatcher() {
        const initial_values = structuredClone(page_navigation.value)
        const ref_dates = structuredClone(page_dates.value)
        if(page_navigation.value.initial === '') {
            // page_dates.value.initial = page_dates.value.current
            page_navigation.value.initial = initial_values.current
            localStorage.setItem('dates', JSON.stringify(page_dates.value.current))
        }
        if(initial_values.initial !== page_navigation.value.current) {
            page_navigation.value.initial = page_navigation.value.current
            localStorage.setItem('dates', JSON.stringify(page_dates.value.current))
        } else {
            if(_.isEmpty(ref_dates.initial)) {
                page_dates.value.initial = page_dates.value.current
                localStorage.setItem('dates', JSON.stringify(page_dates.value.current))

            } else if(!_.isEqual(page_dates.value.initial, page_dates.value.current)) {
                localStorage.setItem('dates', JSON.stringify(ref_dates.initial))
                page_dates.value.initial = page_dates.value.current
            } else localStorage.setItem('dates', JSON.stringify(ref_dates.current))
        }
    }

    function getTransactionDate() {
        if(localStorage.getItem('dates')) {
            return JSON.parse(localStorage.getItem('dates'))
        }
    }

    return {
        table_options,
        isLoading,
        isFilled,
        mode,
        entity_type,
        selected_taxes,
        selected_data,
        user_restriction,
        user_permissions,
        select_all_cbox,
        showInPageAlert,
        copiedTransactions,
        isFromAccounting,
        audit_trail_list,
        password_reqs,
        handleHistoryLogs,
        canUserAccess,
        getPermissions,
        checkUserAccess,
        pageNavigationWatcher,
        page_navigation,page_dates, getTransactionDate
    }
})